import axiosPost from "./axiosPost";

export const RNBeneficiarioGet = async (credentials, data) => {
    const {
        rolCod,
        servicioHooliCod,
        page,
        pageSize,
        usuarioTieneApp,
        usuarioNroDeDocumentoX,
        usuarioApellidos,
        merchantServicioUsuarioStatus,
        fechaDesde,
        fechaHasta,
        fechaTipo,
        billetera,
        asignaciones,
        consumos,
    } = data;
    const body = {
        service: "RNBeneficiarioGet",
        params: {
            rolCod,
            servicioHooliCod,
            page,
            pageSize,
            usuarioTieneApp,
            usuarioNroDeDocumentoX,
            usuarioApellidos,
            merchantServicioUsuarioStatus,
            fechaDesde,
            fechaHasta,
            fechaTipo,
            usuarioTieneBilletera: billetera,
            usuarioTieneAsignacion: asignaciones,
            usuarioTieneConsumo: consumos,
        },
    };

    const result = await axiosPost(body, credentials);

    if (page !== null && pageSize !== null) {
        return {
            result: result.result,
            total: result.status.id,
            status: result.status,
        };
    }
    return result.result;
};
